module.exports = __webpack_public_path__ + "static/img/icon_touxiang 3@2x.4352b8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_touxiang 3@2x.png
// module id = wDJX
// module chunks = 1